import { Injectable } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import {
    ActionOpenOralReadingChartMenu,
    OralReadingChartActionTypes,
    ActionCloseOralReadingChartMenu
} from './oral-reading-chart.actions';

@Injectable()
export class OralReadingChartEffects {
    constructor(
        private actions$: Actions<Action>,
        private menuController: MenuController
    ) {}

    
    openOralReadingChart$ = createEffect(() => this.actions$.pipe(
        ofType<ActionOpenOralReadingChartMenu>(
            OralReadingChartActionTypes.OpenOralReadingChartMenu
        ),
        tap(() => {
            this.menuController
                .enable(true, 'oralReadingChartMenu')
                .then(() => {
                    this.menuController.open('oralReadingChartMenu');
                });
        })
    ), { dispatch: false });

    
    closeOralReadingChart$ = createEffect(() => this.actions$.pipe(
        ofType<ActionCloseOralReadingChartMenu>(
            OralReadingChartActionTypes.CloseOralReadingChartMenu
        ),
        tap(() => {
            this.menuController.close('oralReadingChartMenu');
        })
    ), { dispatch: false });
}
